import React, { useState, Suspense } from 'react';
import UI from "components/UI";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../user1000Aside";
import Button from 'components/buttons/';
import DateUtil from "utils/DateUtil";
import UIInput from 'components/input/input';
import UIDatePicker from "components/datepicker";
import CommonUtil from "utils/CommonUtil";
import ValidationUtil from "common/validation/util/ValidationUtil";
import codeDataStore from "common/codedata/store/CodeDataStore";
import useToggleState from 'components/hooks/useToggleState';
import UIUtils from "utils/UIUtils";
import ModalPopup from 'components/modal/';
import DaumPostcode from "react-daum-postcode";
import UISelect from 'components/selectbox/UISelect';
import UIInputMask from 'components/input/UIInputMask';
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import PageLoading from "../../../../components/loading";

function ContentsContainer() {
    const location = useLocation();
    const receivedData = (location.state as any)?.data;
    const history = useHistory();

	const [corpSizeCd,setCorpSizeCd] = useState('');
    const [acctNo,setAcctNo] = useState('');
    const [corpNm,setCorpNm] = useState('');
    const [induCd,setInduCd] = useState('');
    const [corpRegNo,setCorpRegNo] = useState('');
    const [ceoNm,setCeoNm] = useState('');
    const [evalDivCd,setEvalDivCd] = useState('');
    const [evalCd,setEvalCd] = useState('');
    const [grpNm,setGrpNm] = useState('');
    const [estaDate,setEstaDate] = useState(new Date());
    const [estaFormCd,setEstaFormCd] = useState('');
    const [corpZipCd,setCorpZipCd] = useState('');
    const [corpAddr1,setCorpAddr1] = useState('');
    const [corpAddr2,setCorpAddr2] = useState('');
    const [homepageUrl,setHomepageUrl] = useState('');
    const [regNm,setRegNm] = useState('관리자');
    const [fileId,setFileId] = useState('관리자');
    const [postAddrPopupOpenFlag,set_postAddrPopupOpenFlag] = useState(false);
    const [bizNo, setBizNo] = useState('');
    const [induCdList,setInduCdList] = useState<any[]>([]);
    const [corpSizeCdList,setCorpSizeCdList] = useState<any[]>([]);
    const [estaFormCdList,setEstaFormCdList] = useState<any[]>([]);

    const modalpostcode= useToggleState({});

    const [uploadBiz, setUploadBiz] = useState(false);
    const [loadFinish,setLoadFinish] = useState(false);
    const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
    const [bizFileInfoList, setBizFileInfoList] = React.useState<any[]>([]);

    //파일정보 선언
    const [corpLogoFileValue] = useState(new TbComFile());
    const [bizLicFileValue, setBizLicFileValue] = useState(new TbComFile());
    const defBizLicFileValue = React.useDeferredValue(bizLicFileValue);

    // 폼체크 여부
    const [formCheck,setFormCheck] = useState(false);
    const [fileCheck, setFileCheck] = useState(false);
    const [bizFileCheck, setBizFileCheck] = useState(false);

    //파일업로드
    const [uploadIdBiz, setUploadIdBiz] = React.useState("");
    const [prvtMngr,setPrvtMngr] = useState('');

    //파일업로드
    const onCreationCompleteBiz = function (uploadIdBiz: string) {
        setUploadIdBiz(uploadIdBiz);
    }

    //파일업로드 완료
    const onUploadCompleteBiz = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadIdBiz);
        const arrayNew = dataArray.newFile;
        //const arrayDel = dataArray.deleteFile;

        let bizFileInfos : {
            FILE_DETAIL_ID:string;
            ORGINL_FILE_NM:string;
            STRE_FILE_NM:string;
            FILE_SIZE:number;
            STRE_PATH:string;
            FILE_EXTSN:string;
            FILE_STATUS:string;
        }[] = [];

        let bizFileInfo : {
            FILE_DETAIL_ID:string;
            ORGINL_FILE_NM:string;
            STRE_FILE_NM:string;
            FILE_SIZE:number;
            STRE_PATH:string;
            FILE_EXTSN:string;
            FILE_STATUS:string;
        };

        //파일등록 정보
        arrayNew?.map((item, index) => {
            if(item.status =="complete"){
                bizFileInfo = {
                    FILE_DETAIL_ID:item.uniqKey,
                    ORGINL_FILE_NM:item.originalName,
                    STRE_FILE_NM:item.uploadName,
                    FILE_SIZE:item.size,
                    STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
                    FILE_EXTSN:item.extension,
                    FILE_STATUS:"ADD"
                }

                bizFileInfos.push(bizFileInfo);
            }
        })

        setBizFileInfoList(bizFileInfos);
        setUploadBiz(true);
    }

    async function onFileUploadBiz()  {
		if(uploadIdBiz){
			await window["RAONKUPLOAD"].Transfer(uploadIdBiz);
		}
	}

	//우편번호 찾기 콜백
    const handleComplete = (data) => {
        setCorpZipCd(data.zonecode);
        setCorpAddr1(data.address);
        set_postAddrPopupOpenFlag(false);
        modalpostcode.close();
    };

    //우편번호 찾기 스타일
    const postCodeStyle = {
        display: "block",
    };

    // 내기업 정보 조회
    async function initCall(){

        const response:any = await CommonUtil.execute({
            url: 'usr_1501_r001.jct',
//             data: param
        }).then((response:any) => {
            const result = response;

            setBizNo(result.BIZ_NO);
            setAcctNo(result.ACCT_NO);
            setCorpSizeCd(result.CORP_SIZE_CD);
            setCorpNm(result.CORP_NM);
            setInduCd(result.INDU_CD);
            setCorpRegNo(result.CORP_REG_NO);
            setCeoNm(result.CEO_NM);
            setEvalDivCd(result.EVAL_DIV_CD);
            setEvalCd(result.EVAL_CD);
            setGrpNm(result.GRP_NM);
            setEstaDate(new Date(result.ESTA_DATE));
            setEstaFormCd(result.ESTA_FORM_CD);
            setCorpZipCd(result.CORP_ZIP_CD);
            setCorpAddr1(result.CORP_ADDR_1);
            setCorpAddr2(result.CORP_ADDR_2);
            setHomepageUrl(result.HOMEPAGE_URL);
            setRegNm(result.REG_NM);
            setFileId(result.FILE_ID);
			setPrvtMngr(result.PRVT_MNGR);

            let corpSizeData = codeDataStore.get("[SCS]");
            setCorpSizeCdList(corpSizeData);
            let induCdData = codeDataStore.get("[INC]");
            setInduCdList(induCdData);
            let estaFormData = codeDataStore.get("[EFC]");
            setEstaFormCdList(estaFormData);

            //회사 로고 있을경우
            corpLogoFileValue.setTbComFileMapngDetailList([]);
            if(result.FILE_INFO != null){
                let fileInfo = result.FILE_INFO;
                //파일등록 정보
                fileInfo?.forEach((item, index) => {
                    if(item.DWLD_ID !=null){
                        const vacctChkDetail = new TbComFileMapngDetail();
                        vacctChkDetail.setDwldId(item.DWLD_ID);
                        vacctChkDetail.setFileDetailId(item.FILE_DETAIL_ID);
                        vacctChkDetail.setFilePolicy(item.FILE_POLICY);
                        vacctChkDetail.setFileRpstr(item.FILE_RPSTR);
                        vacctChkDetail.setStrePath(item.STRE_PATH);
                        vacctChkDetail.setStreFileNm(item.STRE_FILE_NM);
                        vacctChkDetail.setOrginlFileNm(item.ORGINL_FILE_NM);
                        vacctChkDetail.setFileExtsn(item.FILE_EXTSN);
                        vacctChkDetail.setFileSize(item.FILE_SIZE);
                        vacctChkDetail.setRegistPsnNm(item.REGIST_PSN_NM);
                        vacctChkDetail.setRegistDt(item.REGIST_DT);
    
                        corpLogoFileValue.putTbComFileMapngDetailList(vacctChkDetail);
                    }
                });
            }

            //사업자 등록증이 있을경우
            bizLicFileValue.setTbComFileMapngDetailList([]);
            if(result.BIZLIC_INFO != null) {
                const tmpBizLicFile = new TbComFile();
                let bizFileInfo = result.BIZLIC_INFO;
                //파일등록 정보
                bizFileInfo?.forEach((item, index) => {
                    if(item.DWLD_ID !=null){
                        const bizLicDetail = new TbComFileMapngDetail();
                        bizLicDetail.setDwldId(item.DWLD_ID);
                        bizLicDetail.setFileDetailId(item.FILE_DETAIL_ID);
                        bizLicDetail.setFilePolicy(item.FILE_POLICY);
                        bizLicDetail.setFileRpstr(item.FILE_RPSTR);
                        bizLicDetail.setStrePath(item.STRE_PATH);
                        bizLicDetail.setStreFileNm(item.STRE_FILE_NM);
                        bizLicDetail.setOrginlFileNm(item.ORGINL_FILE_NM);
                        bizLicDetail.setFileExtsn(item.FILE_EXTSN);
                        bizLicDetail.setFileSize(item.FILE_SIZE);
                        bizLicDetail.setRegistPsnNm(item.REGIST_PSN_NM);
                        bizLicDetail.setRegistDt(item.REGIST_DT);

                        tmpBizLicFile.putTbComFileMapngDetailList(bizLicDetail);
                    }
                })
                setBizLicFileValue(tmpBizLicFile);
            }
            setLoadFinish(true);
        })
    };

    const alertModal = async () => {
        const value = await UIUtils.alert(<>
            필수 입력이 완료되지 않았습니다.<br/>
            다시 확인해 주세요.
        </>);
    }

    //기업 등록전 파일업로드 파라미터 체크
    async function corpFormCheck(){

        // 대표자명 , 업종, 설립일자, 설립형태, 기업규모, 주소, 사업자등록증, 기업로고
        if(ceoNm == "" || induCd == "" || estaFormCd == "" || corpSizeCd == "" || corpZipCd == "" || corpAddr1 == "" || corpAddr2 == ""){
            await UIUtils.alert(<>필수 입력이 완료되지 않았습니다.<br/> 다시 확인해 주세요.</>);
            return;
        }

        const BizFileListInfo = window["RAONKUPLOAD"].GetListInfo("array", uploadIdBiz);
        if(BizFileListInfo?.mergeFile == null){
            await UIUtils.alert(<>필수 입력이 완료되지 않았습니다.<br/> 다시 확인해 주세요.</>);
            return;
        }

        if(await UIUtils.confirm('저장하시겠습니까?')){
            if(uploadIdBiz == ''){
                setUploadBiz(true);
            }else{
                onFileUploadBiz();
            }
        }
    };

    //기업정보 수정
    async function corpUpdate(chkUpdate){
        if(chkUpdate) {
            setUploadBiz(false);

            let param = {
                BIZ_NO:bizNo,
                CORP_REG_NO:corpRegNo,
                CORP_NM:corpNm,
                CEO_NM:ceoNm,
                CORP_SIZE_CD:corpSizeCd,
                INDU_CD:induCd,
                ESTA_DATE:DateUtil.toDateFormat(estaDate, "YYYYMMDDHHmmss"),
                ESTA_FORM_CD:estaFormCd,
                GRP_NM:grpNm,
                EVAL_DIV_CD:evalDivCd,
                EVAL_CD:evalCd,
                CORP_ZIP_CD:corpZipCd,
                CORP_ADDR_1:corpAddr1,
                CORP_ADDR_2:corpAddr2,
                HOMEPAGE_URL:homepageUrl,
                FILE_ID:fileId,
                FILE_INFO_LIST:null,
                BIZ_FILE_INFO_LIST:bizFileInfoList.length>0?bizFileInfoList:null,
            }

            const response:any = await CommonUtil.execute({
                url:'usr_1501_u001.jct',
                data: param
            }).then((response: any) => {
                if(response){
                    UIUtils.alert('저장되었습니다.').then();
                    if(bizFileInfoList.length>0) {
                        window.location.reload();
                    }else {
                        let vBIZ_NO = response.BIZ_NO;
                        let dataToSend = {
                            vBIZ_NO
                        }

                        history.push({
                            pathname: './usr_1501',    //저장후 상세페이지로 이동
                            state: { data: dataToSend }
                        });
                    }
                }
            }).catch(err => {
                CommonUtil.showAxiosError(err);
                return;
            });
        }
    }

    const onClickPage = () => {
        history.push({
            pathname: '/main',
        });
    }

    React.useEffect(() => {
        if(uploadBiz){
            corpUpdate(uploadBiz);
        }
    },[uploadBiz]);

    React.useEffect(() => {
        //필요한 공통코드 로딩.
        codeDataStore.read("/common/useYn", "[EVC]", "[EVDC]", "[SCS]", "[INC]", "[EFC]");

        // let bizNoStorage = localStorage.getItem("bizNo");
        // if (bizNoStorage != null) {
        //     setBizNo(bizNoStorage);
        // }

        //상세데이터 가지고 오기
        initCall();

    }, [])//effect

    if(!loadFinish)
        return (
            <PageLoading />
        )
    else
    return (
        <PageContainer>
            <LayoutAside />
            <Suspense fallback={<PageLoading/>}>
            <div className='fww-con'>
                <ul className="fww-brd">
                    <li><Link to="/main/">홈</Link></li>
                    <li><Link to="/main/usr_1000/usr_1500">마이페이지</Link></li>
                    <li><Link to="#">내기업정보</Link></li>
                </ul>
                <main className="fww-main" data-layout="usr">
                    <div className="mypage">
                        <h1 className="tx tx-hd2">내기업정보</h1>
                        <div className="top-guide">
                            <span className="fc-pri">*</span>&nbsp;필수 입력
                        </div>
                        <form className="fo fo-col2" name="" action="" method="">
                            <div className="inner">
                                <div className="fo-item req">
                                    <p className="fo-key">기업명</p>
                                    <div className="fo-value">
                                        <UIInput type="text" className={'tf tf-md w100p'} value={corpNm} placeholder={'기업명'} readOnly={true}/>
                                    </div>
                                </div>
                                <div className="fo-item req">
                                    <p className="fo-key">대표자명</p>
                                    <div className="fo-value">
                                        <UIInput type="text" className={'tf tf-md w100p'} value={ceoNm} placeholder={'대표자명'} valueChanged={(value) => setCeoNm(value)}/>
                                    </div>
                                </div>
                                <div className="fo-item req">
                                    <p className="fo-key">업종</p>
                                    <div className="fo-value">
                                        <div className="sl sl-md">
                                            <UISelect
                                                codeData={induCdList}
                                                value={induCd}
                                                valueChanged={(value) => setInduCd(String(value))}
                                                rules = {[(value: any) => {
                                                    if (value == "선택") {
                                                        return `그룹을 선택해 주세요.`;
                                                    }
                                                    return undefined;
                                                }]}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="fo-item req">
                                    <p className="fo-key">설립일자</p>
                                    <div className="fo-value">
                                        <div className="w100p">
                                            <UIDatePicker value={estaDate} valueChanged={(value) => setEstaDate(value)} showToday={true}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="fo-item req">
                                    <p className="fo-key">설립형태</p>
                                    <div className="fo-value">
                                        <div className="sl sl-md">
                                            <UISelect
                                                codeData={estaFormCdList}
                                                value={estaFormCd}
                                                valueChanged={(value) => setEstaFormCd(String(value))}
                                                rules={["required"]}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="fo-item req">
                                    <p className="fo-key">기업규모</p>
                                    <div className="fo-value">
                                        <div className="sl sl-md">
                                            <UISelect
                                                codeData={corpSizeCdList}
                                                value={corpSizeCd}
                                                valueChanged={(value) => setCorpSizeCd(String(value))}
                                                rules = {[(value: any) => {
                                                    if (value == "선택") {
                                                        return `그룹을 선택해 주세요.`;
                                                    }
                                                    return undefined;
                                                }]}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="fo-item">
                                    <p className="fo-key">법인등록번호</p>
                                    <div className="fo-value">
                                        <UIInputMask
                                            mask={"999999-9999999"}
                                            className={'tf tf-md w100p'}
                                            value={corpRegNo}
                                            valueChanged={(value) => setCorpRegNo(value)}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                                <div className="fo-item">
                                    <p className="fo-key">사업자등록번호</p>
                                    <div className="fo-value">
                                        <UIInputMask
                                            mask={"999-99-99999"}
                                            className={'tf tf-md w100p'}
                                            value={bizNo}
                                            valueChanged={(value) => setBizNo(value)}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                                {/*
                                <div className="fo-item fo-m-1-3 req">
                                    <p className="fo-key">아이디</p>
                                    <div className="fo-value">
                                        <div className="w-half">
                                            <UIInput className={'tf tf-md w100p'} value={'Idshowing'} placeholder={''} readOnly={true} />
                                        </div>
                                    </div>
                                </div>
                                v0.89삭제 */}
                                <div className="fo-item fo-m-1-3 req">
                                    <p className="fo-key">주소</p>
                                    <div className="fo-value">
                                        <div className="address">
                                            <div className="hz-root hz-gap8">
                                                <UIInput className={'hz-item hz-fg tf tf-md'} value={corpZipCd} valueChanged={(data: any) => setCorpZipCd(data)} placeholder={'우편번호'} disabled={true}/>
                                                <Button color="gray-o" size="md" onClick={modalpostcode.open}>우편번호 찾기</Button>
                                            </div>
                                            <UIInput className={'tf tf-md w100p mt8'} value={corpAddr1} valueChanged={(value) => setCorpAddr1(value)} placeholder={'주소'} disabled={true}/>
                                            <UIInput className={'tf tf-md w100p mt8'} value={corpAddr2}	valueChanged={(value) => setCorpAddr2(value)} placeholder={'상세주소'} />
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="fo-item fo-m-1-3">
                                    <p className="fo-key">홈페이지</p>
                                    <div className="fo-value">
                                        <div className="w-half">
                                            <UIInput className={'tf tf-md w100p'} value={homepageUrl} valueChanged={(value) => setHomepageUrl(value)} placeholder={'홈페이지'}/>
                                        </div>
                                    </div>
                                </div>*/}
								<div className="fo-item fo-m-1-3">
                                    <p className="fo-key">민간자율 기획사업 담당자</p>
                                    <div className="fo-value">
                                        <div className="w-half">
                                            <UIInput className={'tf tf-md w100p'} value={prvtMngr} readOnly={true}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="fo-item fo-m-1-3 req">
                                    <p className="fo-key">사업자등록증</p>
                                    <div className="fo-value">
                                        <div className="w100p">
                                            <Suspense fallback={<PageLoading/>}>
                                                <UI.FileUpload
                                                    onCreationComplete={onCreationCompleteBiz}
                                                    onUploadComplete={onUploadCompleteBiz}
                                                    attrs={{
                                                        MaxTotalFileCount: "1",
                                                        ExtensionAllowOrLimit: "1",
                                                        ExtensionArr: "pdf"
                                                    }}
                                                    value={defBizLicFileValue}
                                                />
                                            </Suspense>
                                        </div>
                                    </div>
                                </div>

                                <div className="fo-item fo-m-1-3">
                                    <p className="fo-key">가상계좌확인서</p>
                                    <div className="fo-value">
                                        <div className="inner w100p">
                                            <Suspense fallback={<PageLoading/>}>
                                                <UI.FileDownload value={corpLogoFileValue !=null?corpLogoFileValue:new TbComFile}/>
                                            </Suspense>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div className="hz-root hz-center hz-gap10">
                            <Button color='gray-o' size="big" onClick={onClickPage}>취소</Button>
                            <Button color='pri' size="big" onClick={() => corpFormCheck()}>저장</Button>
                        </div>
                    </div>
                </main>
            </div>
            </Suspense>
            {/* modal - 우편번호 검색 */}
            <ModalPopup
                open={modalpostcode.isShowing}
                title="우편번호 검색"
                size="sm"
                onClose={modalpostcode.close} >
                <div className="modal-con">
                    <DaumPostcode onComplete={handleComplete} style={postCodeStyle} />
                </div>
            </ModalPopup>
        </PageContainer>
    );
}
export default ContentsContainer;